import React from 'react';

interface Sponsor {
  id: number;
  name: string;
  logo: string;
  description: string;
}

interface SponsorCarouselProps {
  sponsors: Sponsor[];
}

const SponsorCarousel: React.FC<SponsorCarouselProps> = ({ sponsors }) => {
  return (
    <div className="relative overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden py-12">
          {/* Gradient overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10" />
          
          {/* Scrolling track */}
          <div className="sponsor-track animate-scroll">
            {/* First set of sponsors */}
            {sponsors.map((sponsor) => (
              <div key={sponsor.id} className="sponsor-slide">
                <div className="bg-white rounded-lg shadow-md p-4 h-24 flex items-center justify-center hover:shadow-lg transition-shadow duration-300">
                  <img
                    src={sponsor.logo}
                    alt={sponsor.name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {sponsors.map((sponsor) => (
              <div key={`${sponsor.id}-duplicate`} className="sponsor-slide">
                <div className="bg-white rounded-lg shadow-md p-4 h-24 flex items-center justify-center hover:shadow-lg transition-shadow duration-300">
                  <img
                    src={sponsor.logo}
                    alt={sponsor.name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SponsorCarousel;